import moment from "moment";
import Table from "react-bootstrap/Table";
import convertAddress from "../../../components/helpers/convertAddress";

export const DetailDataCustomer = ({
  data,
  handleShowImage,
  dataMembership,
}) => {
  return (
    <Table striped>
      <tbody>
        <tr>
          <td>NIK</td>
          <td>:</td>
          <td>{data?.ktp_number}</td>
        </tr>
        <tr>
          <td>Jenis Kelamin</td>
          <td>:</td>
          <td>{data?.gender === "P" ? "Perempuan" : "Laki-laki"}</td>
        </tr>
        <tr>
          <td>Tanggal Lahir</td>
          <td>:</td>
          <td>{moment(data?.birth_date).format("DD MMMM YYYY")}</td>
        </tr>
        <tr>
          <td>Alamat</td>
          <td>:</td>
          <td>{convertAddress(data)}</td>
        </tr>
        <tr>
          <td>Foto KTP</td>
          <td>:</td>

          <div
            onClick={handleShowImage}
            style={{ color: "#2c465c", cursor: "pointer" }}
          >
            <td>Lihat Foto KTP</td>
          </div>
        </tr>
        {/* <tr>
                <td>Transaksi Terakhir</td>
                <td>:</td>
                <td>-</td>
            </tr> */}
        <tr>
          <td>Email</td>
          <td>:</td>
          <td>{data.email || "-"}</td>
        </tr>
        <tr>
          <td>Kode Referral</td>
          <td>:</td>
          <td>{dataMembership.referralCode || "-"}</td>
        </tr>
        <tr>
          <td>Teman Bergabung</td>
          <td>:</td>
          <td>{dataMembership.friendJoined || 0 + " Teman"}</td>
        </tr>
      </tbody>
    </Table>
  );
};
